/** 支持的格式, 比如 ['.mp3', '.wav'] */
export const defaultSupportAudio = ['.mp3', '.wav']

/** 最大上传音频大小, 单位 MB */
export const maxUploadAudioSize = 15
